import { render, staticRenderFns } from "./ChartWithFtlCompare.vue?vue&type=template&id=04a43066&lang=pug&"
import script from "./ChartWithFtlCompare.vue?vue&type=script&lang=ts&"
export * from "./ChartWithFtlCompare.vue?vue&type=script&lang=ts&"
import style0 from "./ChartWithFtlCompare.vue?vue&type=style&index=0&id=04a43066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports